/**
 * AddSeasonCtrl controller
 * Add/Edit Season TV Shows
 */

import moment from 'moment'
import { TV_SHOW_IMAGES_TYPE } from 'app/core/constants'
import { formatDateByTimezone } from '../../app/helpers/date'
import { openAssignContentSets } from '../common/directives/contentItems/ci.directives'

/**
 * AddSeasonCtrl controller
 *
 * @class AddSeasonCtrl
 * @memberof mwApp/seasons
 * @see mwApp/seasons
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/seasons.controller:AddSeasonCtrl
 */
/* @ngInject */
export default function AddSeasonCtrl ($state, $location, $uibModalInstance, $uibModal, $scope, Season, alertLiteSvc, ss, show, networks, authSvc, alertSvc) {
  var vm = this

  /**
   * Season
   *
   * @memberof mwApp/seasons.controller:AddSeasonCtrl
   * @type {models.Season}
   */
  vm.ss = ss

  /**
   * Show
   *
   * @memberof mwApp/shows.controller:AddSeasonCtrl
   * @type {models.Show}
   */
  vm.show = show

  vm.networks = networks

  /**
   * Current Date
   *
   * @memberof mwApp/season.controller:AddSeasonCtrl
   */
  vm.currentDate = moment().toDate()

  /**
   * isNew flag
   *
   * @memberof mwApp/seasons.controller:AddSeasonCtrl
   * @type {Boolean}
   */
  vm.isNew = ss._isNew()

  /**
   * Datepicker settings
   *
   * @memberof mwApp/shows.controller:AddSeasonCtrl
   * @type {Object}
   */
  vm.dpCfg = {
    format: 'yyyy',
    datepickerMode: 'year',
    startingDay: 1,
    minMode: 'year',
    minDate: moment().year(1900).toDate(),
    maxDate: moment().set('year', moment().year() + 5).toDate()
  }

  /**
   * Images types for TV Show
   *
   * @memberOf mwApp/shows.controller:AddSeasonCtrl
   * @type {Object}
   */
  vm.imagesType = TV_SHOW_IMAGES_TYPE

  /**
   * Handle open "from" datepicker
   *
   * @memberof mwApp/shows.controller:AddSeasonCtrl
   */
  vm.openFrom = function () {
    vm.dpCfg.openedFrom = true
  }

  /**
   * Handle open "to" datepicker
   *
   * @memberof mwApp/shows.controller:AddSeasonCtrl
   */
  vm.openTo = function () {
    vm.dpCfg.openedTo = true
  }

  vm.afterSaveActions = function () {
    if (vm.isNew && authSvc.hasAccess('editVodSeries')) {
      Season.loadAvailableContentSets(ss.tvShow, ss.id)
        .then(data => {
          if (data.length) {
            alertSvc.confirm(`${ss.name} Season has added. <br> Do You want to assign this Season to the TV Show Set(s)?`)
              .then(() => {
                openAssignContentSets($state, $location, ss, true)
              })
          }
        })
    }
  }

  /**
   * Create or edit season, and close modal window afterwards
   *
   * @memberof mwApp/seasons.controller:AddSeasonCtrl
   */
  vm.submit = function (form) {
    for (const control of form.$$controls) {
      control.$setDirty()
      control.$validate()
    }
    if (!vm.ss.publishTime) {
      if (vm.ss.$scheduledPublishing) {
        vm.dpCfgSeason.changeHandler(form)
      }
    }

    if (form.$invalid) {
      return
    }
    vm.setDisable()

    ss._save(null, `${ss._url}`)
      .then(
        () => {
          ss._update()
            .finally(
              () => {
                $uibModalInstance.close(ss)
                vm.unsetDisable()
              }
            )
          $uibModalInstance.close(ss)
        }
      )
      .then(vm.afterSaveActions)
      .finally(vm.unsetDisable)
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/seasons.controller:AddSeasonCtrl
   */
  vm.cancel = function ($event) {
    $event.preventDefault()
    $uibModalInstance.dismiss('cancel')
  }

  //
  // Upload images functional

  /**
   * Upload logo
   *
   * @param file
   * @param type
   * @memberof mwApp/shows.controller:AddSeasonCtrl
   * @function
   */
  function uploadLogo (file, type) {
    return ss._uploadFile(ss._url + '/upload', file, {
      type
    }).data()
  }

  /**
   * Upload Portrait logo
   *
   * @memberof mwApp/shows.controller:AddSeasonCtrl
   * @function
   */
  vm.uploadPortrait = (file) => {
    const _URL = window.URL || window.webkitURL

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      const widthPart = this.width / 2
      const heightPart = this.height / 3
      _URL.revokeObjectURL(objectUrl)
      if (file.size > 10485760) {
        alertLiteSvc.alertError('File bigger than 10 MB')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      if (widthPart / heightPart < 0.98 || widthPart / heightPart > 1.02) {
        alertLiteSvc.alertError('Vertical poster aspect ratio must be 2:3')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      return uploadLogo(file, vm.imagesType.PORTRAIT)
        .then((response) => {
          ss.portraitImageUrl = response.resourceUrl
        }).finally(() => {
          $scope.$broadcast('dndfile.clear', true)
          vm.unsetDisable()
        })
    }
    img.src = objectUrl
  }

  /**
   * Upload Background logo
   *
   * @memberof mwApp/shows.controller:AddSeasonCtrl
   * @function
   */
  vm.uploadBackground = (file) => {
    const _URL = window.URL || window.webkitURL

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      const widthPart = this.width / 16
      const heightPart = this.height / 9
      _URL.revokeObjectURL(objectUrl)
      if (file.size > 10485760) {
        alertLiteSvc.alertError('File bigger than 10 MB')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      if (widthPart / heightPart < 0.98 || widthPart / heightPart > 1.02) {
        alertLiteSvc.alertError('Vertical poster aspect ratio must be 16:9')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      return uploadLogo(file, vm.imagesType.BACKGROUND)
        .then((response) => {
          ss.backgroundImageUrl = response.resourceUrl
        }).finally(() => {
          $scope.$broadcast('dndfile.clear', true)
          vm.unsetDisable()
        })
    }
    img.src = objectUrl
  }

  /**
   * Change Publish Now
   *
   * @memberof mwApp/season.controller:AddSeasonCtrl
   */
  vm.handleChangePublish = function () {
    vm.ss.enabled = !vm.ss.enabled
    if (vm.ss.enabled) {
      vm.ss.$scheduledPublishing = false
      vm.ss.$fromDate = new Date()
      vm.ss.$fromTime = new Date()
      vm.ss.$toDateUnlimited = true
    }
  }

  /**
   * Change Scheduled Publishing
   *
   * @memberof mwApp/season.controller:AddSeasonCtrl
   */
  vm.handleChangeScheduled = function () {
    vm.ss.$scheduledPublishing = !vm.ss.$scheduledPublishing
    if (vm.ss.$scheduledPublishing) {
      vm.ss.enabled = false
    }
  }

  /**
   * Season datepicker settings
   *
   * @memberof mwApp/shows.controller:AddSeasonCtrl
   */
  vm.dpCfgSeason = {
    format: 'dd.MM.yyyy',
    minDate: new Date(),
    changeHandler: function (form, field = null) {
      if (field) {
        form[field].$setTouched()
      } else {
        form.dateFrom.$setTouched()
        form.dateTo.$setTouched()
      }
      const fromDate = vm.ss.$fromDate && vm.ss.$fromDate.setHours(vm.ss.$fromTime.getHours(), vm.ss.$fromTime.getMinutes())
      const toDate = vm.ss.$toDate && vm.ss.$toDate.setHours(vm.ss.$toTime.getHours(), vm.ss.$toTime.getMinutes())
      const minDateStart = fromDate > formatDateByTimezone(Date.now(), false).valueOf()
      const minDateEnd = toDate > formatDateByTimezone(Date.now(), false).valueOf()
      if (field === 'dateFrom' || !field) {
        form.dateFrom.$setValidity('minDate', minDateStart)
        form.dateFrom.$setValidity('after', true)

        if (fromDate && toDate) {
          const after = toDate > fromDate
          if (vm.ss.$toDateUnlimited) {
            form.dateFrom.$setValidity('after', true)
            form.dateTo.$setValidity('earlier', true)
          } else {
            if (form.dateTo.$error && form.dateTo.$error.earlier === true) {
              form.dateTo.$setValidity('earlier', after)
            }
            form.dateFrom.$setValidity('after', after)
          }
        }
      }
      if (field === 'dateTo' || !field) {
        form.dateTo.$setValidity('earlier', true)
        form.dateTo.$setValidity('minDate', true)
        if (!vm.ss.$toDateUnlimited) {
          form.dateTo.$setValidity('minDate', minDateEnd)
          if (fromDate && toDate) {
            const earlier = toDate > fromDate
            if (form.dateFrom.$error && form.dateFrom.$error.after === true) {
              form.dateFrom.$setValidity('after', earlier)
            }
            form.dateTo.$setValidity('earlier', earlier)
          }
        } else {
          form.dateFrom.$setValidity('after', true)
          form.dateFrom.$setValidity('earlier', true)
          form.dateTo.$setValidity('after', true)
          form.dateTo.$setValidity('earlier', true)
        }
      }
    }
  }

  /**
   * Handle open "from" datepicker
   *
   * @memberof mwApp/shows.controller:AddSeasonCtrl
   */
  vm.openSPFrom = function () {
    vm.dpCfgSeason.fromOpened = true
  }

  /**
   * Handle open "to" datepicker
   *
   * @memberof mwApp/shows.controller:AddSeasonCtrl
   */
  vm.openSPTo = function () {
    vm.dpCfgSeason.toOpened = true
  }

  /**
   * table state
   *
   * @type {Object}
   */
  vm.tableState = {
    page: 0,
    count: 25,
    name: '',
    last: false
  }
}
